import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Input, InputField } from "@/components/ui/input";
import React from 'react';
import i18n from 'i18n-js';
import { IconM } from '../media/IconsV2';

const i18nopts = { scope: 'itemInput' }
export default function ItemInput({ item, updateTitle, updateText, infoTitle, infoText }) {

    const onChangeText = text => {
        updateText(text.replace(/&&/, '\n'))
    }

    return (
        <VStack space='sm' className="m-[3px]">
            <Text bold className="text-black text-2xl">{i18n.t(infoTitle, i18nopts)}</Text>
            <Input className="h-[44px] py-1">
                <InputField placeholder={i18n.t('itemInput.title')} value={item.title} onChangeText={updateTitle} selectionColor={"#D2D4D7"} className="font-Assistant text-lg font-[700] text-secondary-900" />
                <IconM className='text-3xl ml-2' onPress={() => { updateTitle('') }} name='clear' />
            </Input>
            <Text bold className="text-black mt-3 text-2xl">{i18n.t(infoText, i18nopts)}</Text>
            <Input className="h-[160px] py-1 mb-4">
                <InputField variant='filled' placeholder={i18n.t('itemInput.text')} value={item.text} onChangeText={onChangeText} selectionColor={"#D2D4D7"} blurOnSubmit={true} returnKeyType='done' multiline={true} textAlignVertical='top' className="font-Assistant text-lg text-secondary-900" />
            </Input>
        </VStack>
    );
}
